import { render, staticRenderFns } from "./Trademark-search.vue?vue&type=template&id=14199554&scoped=true&"
import script from "./Trademark-search.vue?vue&type=script&lang=js&"
export * from "./Trademark-search.vue?vue&type=script&lang=js&"
import style0 from "./Trademark-search.vue?vue&type=style&index=0&id=14199554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14199554",
  null
  
)

export default component.exports